export const normalizeStorageSize = (storageValue: string) => {
  const units = storageValue.slice(-2).toLowerCase()
  const size = storageValue.slice(0, -2)
  if (storageValue.length === 0) return 0

  if (units === 'mb') return parseInt(size)

  if (units === 'gb') {
    return parseInt(size) * 1000
  } else if (units === 'tb') {
    return parseInt(size) * (1000 * 1000)
  }
  return 0
}

export const isAllowedStorageUnits = (value: string) => {
  const allowedUnits: Array<string> = ['mb', 'gb', 'tb']
  return allowedUnits.indexOf(value.slice(-2).toLowerCase()) !== -1
}
